export var PolygonMaskInlineArrangement;
(function (PolygonMaskInlineArrangement) {
    PolygonMaskInlineArrangement["equidistant"] = "equidistant";
    PolygonMaskInlineArrangement["onePerPoint"] = "one-per-point";
    PolygonMaskInlineArrangement["perPoint"] = "per-point";
    PolygonMaskInlineArrangement["randomLength"] = "random-length";
    PolygonMaskInlineArrangement["randomPoint"] = "random-point";
})(PolygonMaskInlineArrangement || (PolygonMaskInlineArrangement = {}));
